import * as Yup from 'yup'
import { Form, InputGroup, Row, Col } from 'react-bootstrap'

type Values = {
  columns: number
  characters: number
}

type Props = {
  values: Values
  errors: Partial<Record<keyof Values, string>>
  touched: Partial<Record<keyof Values, boolean>>
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleBlur: React.FocusEventHandler<HTMLElement>
  handleSubmit: (values: Values) => void
  isSettingWritable: boolean
  rowIndex: number
}

const _PreambleCharacterSettingForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSettingWritable,
  rowIndex
}: Props) => {
  return (
    <Row sm='auto' className={`row-${rowIndex + 1}`}>
      <Col sm={1}>前文{values.columns}段</Col>
      <Col>
        <InputGroup size='sm' hasValidation>
          <Form.Control
            id='charactersInput'
            type='number'
            name='characters'
            value={values.characters || ''}
            onChange={(e) => {
              handleChange(e)
              handleSubmit(values)
            }}
            onBlur={handleBlur}
            isInvalid={!!(touched.characters && errors.characters)}
            disabled={!isSettingWritable}
          />
          <InputGroup.Text>字組</InputGroup.Text>
          <Form.Control.Feedback type='invalid'>{errors.characters}</Form.Control.Feedback>
        </InputGroup>
      </Col>
    </Row>
  )
}

export const PreambleCharacterSettingForm = Object.assign(_PreambleCharacterSettingForm, {
  schema: Yup.object().shape({
    characters: Yup.number().min(1).required()
  })
})
